import { getBuyButtonConfig } from '../utils/commonEntitlements';

export const LLC_FORMATION_CONFIG = {
  hero: {
    buyBox: [
      {
        bulletPoints: [
          { title: 'productPage.llcFormation.buyBox.bulletPoint1' },
          { title: 'productPage.llcFormation.buyBox.bulletPoint2' },
          { title: 'productPage.llcFormation.buyBox.bulletPoint3' },
        ],
        productName: 'productPage.llcFormation.buyBox.productName',
        veloCta: {
          displayVeloCta: true,
          promptMessageId: 'productPage.llcFormation.buyBox.veloCta.prompt',
          topic: 'form-new-llc',
        },
        interactService: {
          service: 'llc_formation',
        },
      },
    ],
    headerPicture: {
      src: '/s2/raster/construction-worker-wiring.png',
      alt: 'productPage.llcFormation.heroPicture.altText',
    },
    headline: 'productPage.llcFormation.page.headline',
    partnerLogo: {},
    partnerReviewBlanks: [],
    subheader: 'productPage.llcFormation.page.subheader',
  },
  benefit: {
    title: 'productPage.llcFormation.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/gppgoodrounded.svg',
        title: 'productPage.llcFormation.valueProp.propTitle1',
        description: 'productPage.llcFormation.valueProp.shortCopy1',
      },
      {
        icon: '/s2/material-icons/paymentsrounded.svg',
        title: 'productPage.llcFormation.valueProp.propTitle2',
        description: 'productPage.llcFormation.valueProp.shortCopy2',
      },
      {
        icon: '/s2/material-icons/workspacepremiumrounded.svg',
        title: 'productPage.llcFormation.valueProp.propTitle3',
        description: 'productPage.llcFormation.valueProp.shortCopy3',
      },
    ],
  },
  highlight: {
    icon: '/s2/material-icons/helpoutlinerounded.svg',
    title: 'productPage.llcFormation.topFeature.title',
    subheader: 'productPage.llcFormation.topFeature.subheader',
    image: '/s2/raster/open-sign-smiling.png',
    alt: 'productPage.llcFormation.topFeature.altText',
  },
  howItWorks: {
    title: 'productPage.llcFormation.howItWorks.title',
    items: [
      {
        title: 'productPage.llcFormation.howItWorks.step1',
        description: 'productPage.llcFormation.howItWorks.shortDescription1',
      },
      {
        title: 'productPage.llcFormation.howItWorks.step2',
        description: 'productPage.llcFormation.howItWorks.shortDescription2',
      },
      {
        title: 'productPage.llcFormation.howItWorks.step3',
        description: 'productPage.llcFormation.howItWorks.shortDescription3',
      },
      {
        title: 'productPage.llcFormation.howItWorks.step4',
        description: 'productPage.llcFormation.howItWorks.shortDescription4',
      },
    ],
    image: '/s2/raster/laptop-phone-boxes.png',
    alt: 'productPage.llcFormation.howItWorks.altText',
    hasNumber: true,
    hasDivider: false,
    hasMobileImage: true,
  },
  faqs: {
    title: 'productPage.llcFormation.frequentlyAskedQuestions.title',
    items: [
      {
        question: 'productPage.llcFormation.frequentlyAskedQuestions.faq1',
        answer: 'productPage.llcFormation.frequentlyAskedQuestions.faqAnswer1',
      },
      {
        question: 'productPage.llcFormation.frequentlyAskedQuestions.faq2',
        answer: 'productPage.llcFormation.frequentlyAskedQuestions.faqAnswer2',
      },
      {
        question: 'productPage.llcFormation.frequentlyAskedQuestions.faq3',
        answer: 'productPage.llcFormation.frequentlyAskedQuestions.faqAnswer3',
      },
    ],
  },
  assistance: {
    title: 'productPage.llcFormation.needAssistance.title',
    getInTouch: 'productPage.llcFormation.needAssistance.getInTouch',
    actions: 'productPage.llcFormation.needAssistance.actions',
  },
  getBuyButtonConfig: (entitlements, service) =>
    getBuyButtonConfig({
      entitlements,
      service,
      ctaText: 'productPage.llcFormation.buyBox.buttonLabel',
    }),
};
